document.addEventListener('DOMContentLoaded', function () {
  const modalOverlay = document.querySelector('.custom-message-modal-overlay');
  const ajaxUrl = ajax_callback_data.ajax_url;
  const nonce = ajax_callback_data.ajax_nonce;

  let productIdToDelete = null;
  let deleteRow = null;

  /**
   * Display a message in the modal and create a footer button.
   * @param {string} message - Message to show.
   * @param {function|null} onConfirm - Function to run on confirm.
   * @param {string} confirmText - Button text.
   */
  function showModalMessage(message, title = 'Action required', onConfirm = null, confirmText = 'Ok') {
    const modalFooter = document.querySelector('.custom-message-modal-footer');
    const modalMessage = document.querySelector('.custom-message-modal-body p');
    const modalTitle = document.querySelector('.custom-message-modal-header h2');
    const modalTriggerBtn = document.querySelector('.open-modal-btn');

    // Set modal title
    if (modalTitle) {
      modalTitle.textContent = title;
    }

    // Set modal message
    if (modalMessage) {
      modalMessage.innerHTML = `<p class="whitespace-pre-line">${message}</p>`;
    }

    // Clear footer and add new button
    if (modalFooter) {
      modalFooter.innerHTML = '';

      const confirmButton = document.createElement('button');
      confirmButton.className = 'custom-message-modal-btn btn btn-primary btn-xs dynamic-confirm';
      confirmButton.textContent = confirmText;

      confirmButton.onclick = () => {
        if (typeof onConfirm === 'function') {
          onConfirm(); // Perform the async action (e.g. delete)
        } else {
          // Close the modal if no action needed
          const modal = document.querySelector('.custom-message-modal-overlay');
          if (modal) modal.classList.remove('d-flex');
        }
      };

      modalFooter.appendChild(confirmButton);
    }

    // Show the modal
    if (modalTriggerBtn) {
      modalTriggerBtn.click();
    }
  }

  // Handle delete-product button click
  document.querySelectorAll('.product-actions .delete-product').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      productIdToDelete = this.getAttribute('data-product-id');
      deleteRow = this.closest('tr');

      const confirmDelete = () => {
        const modalBody = document.querySelector('.custom-message-modal-body p');
        const confirmButton = document.querySelector('.custom-message-modal-btn.dynamic-confirm');
        const modalTitle = document.querySelector('.custom-message-modal-header h2');
        // Show processing message
        if (modalTitle) {
          modalTitle.textContent = 'Please wait';
        }
        if (modalBody) {
          modalBody.textContent = 'Deleting product...';
        }

        // Hide confirm button while processing
        if (confirmButton) {
          confirmButton.style.display = 'none';
        }



        // Perform deletion via AJAX
        fetch(ajaxUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: `action=delete_user_product&product_id=${productIdToDelete}&_wpnonce=${nonce}`
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            if (deleteRow) {
              deleteRow.style.transition = 'opacity 0.3s ease';
              deleteRow.style.opacity = '0';
              setTimeout(() => {
                deleteRow.remove()
                const productItems = document.querySelectorAll('.product-item');
                if (productItems.length === 0) {
                  document.querySelector('.product-list-item').innerHTML = '<tr><td colspan="4">No products found</td></tr>';
                }
              }, 300);
            }
            // Show success message with close button
            showModalMessage('Product deleted successfully', 'Confirmation');
            
            
          } else {
            showModalMessage(data.data.message || 'Something went wrong. Please try again.');
          }
          productIdToDelete = null;
        })
        .catch(error => {
          console.error('AJAX error:', error);
          showModalMessage('An error occurred. Please try again.');
          productIdToDelete = null;
        });
      };

      // Show initial confirmation prompt
      showModalMessage(
        'Are you sure you want to delete this product?',
        'Confirmation',
        confirmDelete,
        'Confirm'
      );
    });
  });
});